import React, { useEffect } from 'react'
import { useQuery } from 'apollo-client'
import localStorage from 'local-storage'

import GlobalLoader from 'compositions/GlobalLoader/GlobalLoader'
import initialDataQuery from './util/initialData.graphql'


// ATTN Initial data it's a first request and we should wait for it to execute to get a session for the user
const InitialData: React.CFC<{ isLightweightSSR?: boolean }> = ({ children, isLightweightSSR }) => {
  const { data, error, isFetching } = useQuery(initialDataQuery, {
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
    ssr: !isLightweightSSR,
  })

  const tokenApi = data?.currentUser?.data?.personalInfo?.tokenApi

  useEffect(() => {
    // set token for WS connection
    if (tokenApi) {
      localStorage.setSessionItem('tokenApi', tokenApi)
    }
    else {
      localStorage.removeSessionItem('tokenApi')
    }
  }, [ tokenApi ])

  if (isFetching) {
    return (
      <GlobalLoader />
    )
  }

  if (error) {
    throw error
  }

  return (
    <>{children}</>
  )
}


export default InitialData
